import React, { useEffect, useState } from 'react';

// API/Components
import { isEmpty, formatDateTime, ANALYSIS_TYPE } from './enums';
import { BuildDataGridMeasurementCell, BuildDataGridCell } from './ui_helpers';
import NoItemsOverlay from '../components/no_items_overlay';

// Material UI
import { DataGrid } from '@mui/x-data-grid';


// Unit Snapshot Report table columns
const columns = [
	{
		field: 'datetime',
		headerName: 'Measurement',
		description: 'Measurement Date and Time',
		minWidth: 170,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => formatDateTime(params.value),
	},
	{
		field: 'time_elapsed',
		headerName: 'Time Elapsed',
		description: 'Time Elapsed',
		minWidth: 120,
		flex: 0.5,
		headerAlign: "center",
		renderCell: (params) => BuildDataGridCell(params.value),
	},
	{
		field: 'voltage',
		headerName: 'String Voltage',
		description: 'String Voltage',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.STRING_VOLTAGE),
	},
	{
		field: 'current',
		headerName: 'String Current',
		description: 'String Current',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.CURRENT),
	},
];


export default function StringTrendReport(props) {
	const { trendData, loading, noCurrentMeasurement } = props;
	
	const [reportTrendData, setReportTrendData] = useState([]);
	const [isLoading, setIsLoading] = useState(loading);
	const [pageSize, setPageSize] = useState(100);

	// Filter columns based on noCurrentMeasurement flag
	const visibleColumns = noCurrentMeasurement 
		? columns.filter(col => col.field !== 'current')
		: columns;
	
	useEffect(() => {
		const formattedData = FormatDataForReport(trendData);
		if (formattedData !== undefined && formattedData !== null) {
			setReportTrendData(formattedData);
		}
	}, [trendData]);

	useEffect(() => {
		setIsLoading(loading);
	}, [loading]);
	
	function FormatDataForReport(trendData) {
		setIsLoading(true);
		let rows = [];
		if (trendData !== null && trendData !== undefined && !isEmpty(trendData)) {
			trendData.measurements?.forEach(meas => {
				rows.push({
					datetime: meas.datetime,
					time_elapsed: meas.time_elapsed,
					voltage: {
						measurement: meas.voltage.measurement,
						result: meas.voltage.analysis_result,
						out: meas.voltage.analysis_out,
						valid: meas.voltage.analysis_valid,
					},
					current: {
						measurement: meas.current.measurement,
						result: meas.current.analysis_result,
						out: meas.current.analysis_out,
						valid: meas.current.analysis_valid,
					},
				});
			});
		}
		
		setIsLoading(false);
		return rows;
	}
	
	return (
		<DataGrid
			getRowId={(row) => `${row.datetime}`}
			rows={reportTrendData}
			columns={visibleColumns}
			loading={isLoading}
			density="compact"
			pagination
			pageSize={pageSize}
			onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
			pageSizeOptions={[25, 50, 100]}  // Max pagination size for DataGrid (Free Edition) is 100
			slots={{
				noRowsOverlay: NoItemsOverlay,
			}}
			slotProps={{
				noRowsOverlay: { noItemsText: 'No String Discharge Trend Data' },
			}}
			sx={{
				padding: 1,
				height: '100%'
			}}
		/>
	);
}